class CustomCursor extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    if (!window.BAO.MediaBreakpoints.isMd) return

    this.cursorPosition = {
      x: -100,
      y: -100,
    }

    this.activeCursor = ''

    this.isTicking = false

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    window.setTimeout(() => {
      this.updateEl()
    }, 500)
  }

  setupListeners () {
    super.setupListeners()

    if (!window.BAO.MediaBreakpoints.isMd) return

    this.onMouseMove = this.onMouseMove.bind(this)
    this.onCloseCursorType = this.onCloseCursorType.bind(this)

    this.externalEls.close.elements.forEach((externalCloseEl) => {
      this.listeners.add(externalCloseEl, 'click', this.onCloseCursorType)
    })

    window.addEventListener('pointermove', this.onMouseMove)
  }

  onCloseCursorType () {
    this.els.cursor.elements.forEach((cursorEl) => {
      cursorEl.setAttribute('aria-hidden', true)
    })
  }

  onMouseMove (event) {
    this.cursorPosition = {
      x: event.clientX,
      y: event.clientY,
    }

    this.activeCursor = !event.target.closest(
      `.btn-Button, .wsh-Trigger, .drw-Drawer, .clc-SubCollections, .clc-SubCollectionsBasic, .prd-ColoursCarousel_Carousel`,
    )
      ? event.target.closest(`[data-custom-cursor-external-el]`)
      : ''

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.updateCursor()
  }

  updateCursor () {
    this.style.setProperty('--Position_X', `${this.cursorPosition.x}px`)
    this.style.setProperty('--Position_Y', `${this.cursorPosition.y}px`)

    const activeCursorType = !this.activeCursor
      ? ''
      : this.activeCursor.dataset.customCursorExternalEl

    const cursorEls = this.querySelectorAll('[data-custom-cursor-el="cursor"]')

    cursorEls.forEach((cursorEl) => {
      cursorEl.setAttribute(
        'aria-hidden',
        cursorEl.dataset.cursor !== activeCursorType,
      )
    })
  }
}

if (!customElements.get('custom-cursor')) {
  customElements.define('custom-cursor', CustomCursor)
}
